import React, { Suspense } from 'react';

import { Provider } from 'react-redux';
import { Router, Route, Switch, Redirect } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { ToastContainer } from 'react-toastify';

import history from '~/services/history';
import { store, persistor } from '~/store';
import ScrollToTop from '~/components/ScrollToTop';
import AuthLayout from '~/layouts/Auth';
import ClientLayout from '~/layouts/Client';
import AppProvider from '~/context';
import ReactGA4 from 'react-ga4';
import { TokenProvider } from './context/TokenContext';


function App() {
	ReactGA4.initialize('G-T5QDV3Z20D')

	return (
		<Suspense>
			<Provider store={store}>
				<PersistGate loading={null} persistor={persistor}>
					<Router history={history}>
						<ScrollToTop />

						<Switch>
							<Route
								path="/auth"
								render={(props) => (
									<>
										<TokenProvider>
											<AuthLayout {...props} />
										</TokenProvider>
									</>

								)}
							/>

							<Route
								path="/client"
								render={(props) => (
									<AppProvider>
										<ClientLayout {...props} />
									</AppProvider>
								)}
							/>

							<Redirect to="/auth/login" />
						</Switch>
					</Router>
					<ToastContainer
						autoClose={5000}
						position="top-center"
						newestOnTop
						pauseOnHover={false}
					/>

				</PersistGate>
			</Provider>
		</Suspense>
	);
}

export default App;
